import * as React from 'react'
import { ReactElement } from 'react'
import BaseTagPicker, { BaseTagPickerProps } from './BaseTagPicker'
import { ActiveUserStatuses, UserListItemDto } from '../../config/userConfig'
import useUsers from '../../hooks/useUsers'
import useUser from '../../hooks/useUser'

export type UserPickerProps = Partial<BaseTagPickerProps<UserListItemDto>> &
    Required<Pick<BaseTagPickerProps<UserListItemDto>, 'selectedOptions' | 'onOptionsSelect'>>

export default function UserPicker(props: UserPickerProps): ReactElement {
    const { currentUser } = useUser()
    const { users } = useUsers()

    return (
        <BaseTagPicker<UserListItemDto>
            entities={users}
            filter={entity =>
                props.filter?.(entity) ??
                (currentUser?.id === entity.id || ActiveUserStatuses.includes(entity.status) || props.selectedOptions?.some(id => id === entity.id))
            }
            alphabetical
            getEntityValue={user => user.id}
            getEntityTagLabel={file => file.fullName}
            getEntityLabel={user => user.fullName}
            placeholderKey={'base.userpicker.placeholder'}
            {...props}
        />
    )
}
